import request from '@/utils/request.js'
import { V3 } from '@/utils/config.js'


// Basic
export function getRoutes(params) {
    return request({
        url: '/'+ V3 +'/routes',
        method: 'get',
        params,
    })
}

export function saveRoute(data) {
    return request({
        url: '/'+ V3 +'/routes',
        method: 'post',
        data,
    })
}

export function getRoute(id) {
    return request({
        url: '/'+ V3 +'/routes/' + id,
        method: 'get',
    })
}

export function updateRoute(id, data) {
    return request({
        url: '/'+ V3 +'/routes/' + id,
        method: 'patch',
        data
    })
}


export function updateRouteStatus(ids, status) {
    return request({
        url: '/'+ V3 +'/routes/status',
        method: 'patch',
        data: {
            ids,
            status
        }
    })
}


// Assignment
export function getRouteAssignment(id) {
    return request({
        url: '/'+ V3 +'/routes/' + id + '/assignment',
        method: 'get',
    })
}

export function updateRouteAssignment(id, data) {
    return request({
        url: '/'+ V3 +'/routes/' + id + '/assignment',
        method: 'patch',
        data
    })
}

// Settings
export function getRouteSettings(id) {
    return request({
        url: '/'+ V3 +'/routes/' + id + '/settings',
        method: 'get',
    })
}

export function updateRouteSettings(id, data) {
    return request({
        url: '/'+ V3 +'/routes/' + id + '/settings',
        method: 'patch',
        data
    })
}


// Stops
export function getRouteStops(id) {
    return request({
        url: '/'+ V3 +'/routes/' + id + '/stops',
        method: 'get',
        params: {
            size: -1
        }
    })
}

export function saveRouteStop(id, data) {
    return request({
        url: '/'+ V3 +'/routes/' + id + '/stops',
        method: 'post',
        data
    })
}

export function updateRouteStop(id, data) {
    return request({
        url: '/'+ V3 +'/routes/' + id + '/stops/' + data.id,
        method: 'patch',
        data
    })
}

export function removeRouteStop(id, stop_id) {
    return request({
        url: '/'+ V3 +'/routes/' + id + '/stops/' + stop_id,
        method: 'delete',
    })
}

export function updateRouteStopSequence(id, stop_seqs) {
    return request({
        url: '/'+ V3 +'/routes/' + id + '/stops/sequence',
        method: 'patch',
        data: {
            stop_seqs
        }
    })
}

// Students
export function getRouteStudents(id) {
    return request({
        url: '/'+ V3 +'/routes/' + id + '/students',
        method: 'get',
        params: {
            size: -1
        }
    })
}

export function assignRouteStudent(id, data) {
    return request({
        url: '/'+ V3 +'/routes/' + id + '/students',
        method: 'post',
        data
    })
}

export function unAssignRouteStudent(id, student_id) {
    return request({
        url: '/'+ V3 +'/routes/' + id + '/students/' + student_id,
        method: 'delete',
    })
}

export function patchAssignRouteStudent(id, students) {
    return request({
        url: '/'+ V3 +'/routes/' + id + '/students/bulk',
        method: 'post',
        data: {
            students
        }
    })
}

export function patchUnAssignRouteStudent(id, student_ids) {
    return request({
        url: '/'+ V3 +'/routes/' + id + '/students/bulk',
        method: 'delete',
        data: {
            student_ids
        }
    })
}

export function getCandidateStudents(id, params={size: -1}) {
    return request({
        url: '/'+ V3 +'/routes/' + id +'/candidate-students',
        method: 'get',
        params,
    })
}


// Manifest
export function getRouteManifest(id, date) {
    return request({
        url: '/'+ V3 +'/routes/' + id + '/manifest',
        method: 'get',
        params: {
            q: {
                date
            }
        }
    })
}


// Direction
export function getRouteDirections(id) {
    return request({
        url: '/'+ V3 +'/routes/' + id + '/directions',
        method: 'get',
    })
}

export function updateRouteDirections(id) {
    return request({
        url: '/'+ V3 +'/routes/' + id + '/directions',
        method: 'patch',
    })
}


// Trip history
export function getRouteTrips(id, params) {
    return request({
        url: '/'+ V3 +'/routes/' + id + '/trips',
        method: 'get',
        params
    })
}


// Waypoints
export function getRouteWaypoints(route_id) {
    return request({
        url: '/'+ V3 + '/routes/'+ route_id +'/waypoints',
        method: 'get',
    })
}

export function saveRouteWaypoint(route_id, data) {
    return request({
        url: '/'+ V3 +'/routes/'+ route_id +'/waypoints',
        method: 'post',
        data,
    })
}

export function updateRouteWaypoint(route_id, waypoint_id, data) {
    return request({
        url: '/'+ V3 +'/routes/'+ route_id +'/waypoints/' + waypoint_id,
        method: 'patch',
        data,
    })
}

export function deleteRouteWaypoint(route_id, waypoint_id) {
    return request({
        url: '/'+ V3 +'/routes/'+ route_id +'/waypoints/' + waypoint_id,
        method: 'delete',
    })
}

export function deleteRouteWaypoints(route_id, ids) {
    return request({
        url: '/'+ V3 +'/routes/'+ route_id +'/waypoints',
        method: 'delete',
        data: {ids}
    })
}

export function updateRouteWaypointsSeq(route_id, data) {
    return request({
        url: '/'+ V3 +'/routes/'+ route_id +'/waypoints/sequence',
        method: 'patch',
        data,
    })
}

// Duplicate
export function duplicateRoute(id, data) {
    return request({
        url: '/'+ V3 +'/routes/' + id + '/duplicate',
        method: 'post',
        data
    })
}
